export default __webpack_public_path__ + "static/media/Male.ec44ed89.jpg";